/* eslint-disable max-len */
import React, { Fragment, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRoomContext } from '../../../../../RoomContext';
import { withStyles } from '@material-ui/core/styles';
import { useIntl, FormattedTime, FormattedMessage } from 'react-intl';
import IconButton from '@material-ui/core/IconButton';
import DescriptionIcon from '@material-ui/icons/Description';
import classnames from 'classnames';
import GetAppIcon from '@material-ui/icons/GetApp';
import Tooltip from '@material-ui/core/Tooltip';
import Alert from '@material-ui/lab/Alert';
import PlayArrowRoundedIcon from '@material-ui/icons/PlayArrowRounded';
import './styles.css';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import PauseIcon from '@material-ui/icons/Pause';
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';
import { toast } from 'react-toastify';
import { makePermissionSelector } from '../../../../../store/selectors';
import { permissions } from '../../../../../permissions';
import Preview from '../../../../popups/docShare/myFiles/components/preview';

const styles = (theme) =>
	({
		root :
	{
		display    : 'flex',
		flexShrink : 0,
		// backgroundColor : '#a9daeb',
		boxShadow  : 'none',
		padding    : '0.5rem 0',
		wordWrap   : 'break-word',
		// wordBreak  : 'break-all',
		alignItems : 'center',
		position   : 'relative'

	},
		single :
	{
		marginTop    : theme.spacing(1),
		borderRadius : '10px 10px 10px 10px'
	},
		combinedBegin :
	{
		marginTop    : theme.spacing(1),
		borderRadius : '10px 10px 0px 0px'
	},

		combinedMiddle :
	{
		marginBottom : theme.spacing(0),
		borderRadius : '0px 0px 0px 0px'
	},
		combinedEnd :
	{
		marginBottom : theme.spacing(0),
		borderRadius : '0px 0px 10px 10px'
	},
		combinedTime :
	{
		width          : '75px',
		alignSelf      : 'center',
		fontSize       : '13px',
		color          : '#000000ab',
		display        : 'flex',
		justifyContent : 'center'

	},
		sent :
	{
		maxWidth      : '100%',
		flexDirection : 'row-reverse',
		width     		  : '100%'
	},
		received :
	{
		alignItems : 'flex-end',
		maxWidth   : '100%',
		width  		  : '100%'
	},
		name : {

		},
		avatar : {
			display        : 'flex',
			justifyContent : 'center',
			padding        : '12px 6px 20px 0px',
			'& img'        : {
				borderRadius    : '50%',
				width           : '2rem',
				height          : '2rem',
				alignSelf       : 'center',
				objectFit       : 'cover',
				backgroundColor : '#e0e0e085'
			}
		},
		meContent :
	{
		display       : 'flex',
		flex          : 'none',
		flexDirection : 'column',
		maxWidth      : 'calc(100% - 150px)',
		alignItems    : 'flex-end',
		marginTop     : '8px',
		paddingRight  : '8px',
		'& p'         : {
			margin : '0'
		}
	},
		peerContent :
	{
		display       : 'flex',
		flex          : 'none',
		flexDirection : 'column',
		position   	  : 'relative',
		maxWidth      : 'calc(100% - 150px)',
		marginTop     : '8px',
		'& p'         : {
			margin : '0'
		}
	},
		'@keyframes fadeIn' : {
			'from' : {
				backgroundColor : '#24a4c4'
			},
			'to' : {
				backgroundColor : '#e0e0e085'
			}
		},
		isseen : {
			animation         : '$fadeIn 2s linear',
			animationFillMode : 'forwards'
		},
		text :
	{
		display       : 'flex',
		flex          : '1',
		flexDirection : 'column',
		padding       : '0px 4px',
		wordBreak  	  : 'break-word',
		overflow      : 'hidden'
		// padding       : '8px'
	},
		fileInfo :
	{
		display    : 'flex',
		alignItems : 'center',
		padding    : '0',
		cursor     : 'pointer'
	},
		displayFile :
	{
		width        : '100%',
		height       : 'auto',
		overflow     : 'hidden',
		aspectRatio  : '18/9',
		borderRadius : '4px',
		position     : 'relative'
	},
		imgFile :
	{
		width        : '100%',
		height       : 'auto',
		objectFit    : 'cover',
		borderRadius : '8px',
		cursor       : 'pointer'
	},
		imgFilePrev :
	{
		width        : 'auto',
		height       : 'auto',
		maxWidth   	 : '100%',
		maxHeight  	 : '100%',
		objectFit    : 'cover',
		borderRadius : '8px',
		cursor       : 'pointer'
	},
		videoFile :
	{
		width        : '100%',
		height       : 'auto',
		borderRadius : '8px',
		cursor       : 'pointer'
	},
		previewWindow :
	{
		position        : 'fixed',
		height          : '100vh',
		width           : '100vw',
		display         : 'flex',
		flex            : 'none',
		flexDirection   : 'column',
		gap             : '16px',
		zIndex          : '2000',
		left            : '0',
		top             : '0',
		backgroundColor : '#043040'
	},
		cImg :
	{
		width   : '36px',
		height  : '36px',
		padding : '4px',
		cursor  : 'pointer'
	},
		previewElememt :
	{
		height                         : 'calc(100% - 38px)',
		width                          : '100%',
		padding                        : '0 10rem',
		display                        : 'flex',
		flex                           : 'none',
		overflowY                      : 'auto',
		flexDirection                  : 'column',
		[theme.breakpoints.down('md')] : {
			padding : '16px 0px',
			height  : 'calc(100% - 82px)'
		}
	},
		previewSub :
	{
		display        : 'flex',
		alignItems   	 : 'center',
		justifyContent : 'center',
		width          : '100%',
		height         : '100%',
		aspectRatio    : '16/9',
		borderRadius   : '8px',
		overflow       : 'hidden'

	}
	});

const File = (props) =>
{

	const intl = useIntl();

	const {
		roomClient,
		name,
		canShareFiles,
		url,
		time,
		file,
		classes,
		sender,
		isseen,
		format,
		refMessage,
		avatar,
		chatBackgroundColor,
		fileName,
		fileType,
		size,
		webinarUser,
		me,
		peerId,
		index,
		isPlaying,
		setIsPlaying,
		item,
		setReplyData,
		isModerator,
		setFileUrl, fileUrl
	} = props;

	const [ preview, setPreview ] = useState({ open: false, data: null });
	const audioRef = useRef(null);
	const [ currentTime, setCurrentTime ] = useState(0);
	const [ duration, setDuration ] = useState(0);
	const avatarRef = useRef(null);
	const msgRef = useRef(null);
	// const [ totalWidth, setTotalWidth ] = useState(0);

	const handlePreview = (data) =>
	{
		setPreview({ open: !preview.open, data: data });
		setFileUrl({
			fileName : fileName,
			fileType : fileType,
			fileURL  : url
		});
	};

	const handlePauseOtherAudios = () =>
	{
		const audioElements = document.querySelectorAll('#broadcastaudio');

		audioElements.forEach((audio) =>
		{
			if (audio !== audioRef.current)
			{
				audio.pause();
			}
		});
	};

	// console.log('sende', peerId, window.btoa(me.email));
	const handlePlay = () =>
	{
		const audioElement = audioRef.current;

		handlePauseOtherAudios();

		if (isPlaying===index)
		{
			audioElement.pause();
			setIsPlaying(null);
		}
		else
		{
			audioElement.play();
			setIsPlaying(index);
		}

	};
	const [ imageError, setImageError ] = useState(false);

	const handleImageError = () =>
	{
		setImageError(true);
	};

	const handleDownload = () =>
	{
		// fetch(file?.url)
		// 	.then((response) =>
		// 	{
		// 		if (!response.ok)
		// 		{
		// 			throw new Error('Network response was not ok');
		// 		}

		// 		return response.blob();
		// 	})
		// 	.then((blob) =>
		// 	{
		// 		const Url = window.URL.createObjectURL(blob);

		// 		const a = document.createElement('a');

		// 		a.style.display = 'none';
		// 		a.href = Url;
		// 		a.download = file?.fileName;
		// 		document.body.appendChild(a);
		// 		a.click();
		// 		window.URL.revokeObjectURL(url);
		// 		document.body.removeChild(a);
		// 	})
		// 	.catch((error) =>
		// 	{
		// 		console.error(intl.formatMessage({ id: 'Error_downloading_file', defaultMessage: 'Error downloading file' }), error);
		// 	});
		try
		{
			const link = document.createElement('a');

			link.href = url;
			link.download = fileName;
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		}
		catch (error)
		{
			toast.error('Download failed');
			console.log(error);
		}

	};

	useEffect(() =>
	{
		const audioElement = audioRef.current;

		if (!audioElement) return;

		const handleTimeUpdate = () =>
		{
			setCurrentTime(audioElement.currentTime);
		};

		const handleLoadedMetadata = () =>
		{
			setDuration(audioElement.duration);
		};
		const handleAudioEnd = () =>
		{
			if (isPlaying === index)
			{
				setIsPlaying(null);
				setCurrentTime(0);
			}
		};

		audioElement.addEventListener('timeupdate', handleTimeUpdate);
		audioElement.addEventListener('loadedmetadata', handleLoadedMetadata);
		audioElement.addEventListener('ended', handleAudioEnd);

		return () =>
		{
			audioElement.removeEventListener('timeupdate', handleTimeUpdate);
			audioElement.removeEventListener('loadedmetadata', handleLoadedMetadata);
			audioElement.removeEventListener('ended', handleAudioEnd);
		};
	}, [ isPlaying ]);

	const formatTime = (timeInSeconds) =>
	{
		const minutes = Math.floor(timeInSeconds / 60);
		const seconds = Math.floor(timeInSeconds % 60);

		return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
	};

	const calculateProgress = () =>
	{
		if (!audioRef.current || !duration) return 0;

		return (currentTime / duration) * 100;
	};

	// useEffect(() =>
	// {
	// 	// Ensure the refs are set before calculating width
	// 	if (avatarRef.current && msgRef.current)
	// 	{
	// 		const width1 = avatarRef.current.offsetWidth;
	// 		const width2 = msgRef.current.offsetWidth;

	// 		setTotalWidth(width1 + width2 + 12);
	// 	}
	// }, []);

	return (
		<div
			className={classnames(
				classes.root,
				peerId === window.btoa(me.email) ? classes.sent : classes.received,
				// isseen && sender === 'response' ? classes.isseen : null,
				classes[format], 'parentMsg'
			)}
			data-name={name}
			data-isseen={isseen}
			data-time={time}
			// ref={refMessage}
		>
			{peerId !== window.btoa(me.email) &&
				<div className={classes.avatar} ref={avatarRef}>
					{/* <img src={avatar} alt='Avatar' /> */}
					<img onError={(e) => { e.target.onerror = null; handleImageError(); }} src={avatar && avatar !== '' && !imageError ? `https://${import.meta.env.VITE_s3Bucket}.s3.${import.meta.env.VITE_s3Region}.amazonaws.com/public/profileImages/${avatar}` : 'images/avatar.svg'} alt='Avatar' />
				</div>
			}
			<div ref={msgRef} className={peerId === window.btoa(me.email) ? classes.meContent : classes.peerContent}>
				<div className={peerId === window.btoa(me.email) ? 'meMsg' : 'peerMsg'} style={peerId === window.btoa(me.email) ? { backgroundColor: '#a9daeb', borderColor: '#a9daeb' } : { backgroundColor: '#eaecf2', borderColor: '#eaecf2' }}>
					{peerId === window.btoa(me.email) ? '' : <small>{name}</small> }
					{(fileType === 'image' || fileType === 'video' || fileType === 'audio') ? (fileType === 'audio' ?
						<div style={{ display: 'flex', alignItems: 'center' }}>
							<audio id='broadcastaudio' ref={audioRef} src={url}/>
							<IconButton onClick={handlePlay} aria-label={isPlaying===index ? 'Pause' : 'Play'}>
								{isPlaying===index ? <PauseIcon /> : <PlayArrowIcon />}
							</IconButton>
							<Typography variant='body1' style={{ margin: '0 10px' }}>
								{formatTime(currentTime)} / {formatTime(duration)}
							</Typography>

							<LinearProgress variant='determinate' value={calculateProgress()} style={{ flexGrow: 1, height: '10px' }} />

							<IconButton onClick={handleDownload} aria-label='Download'>
								<GetAppIcon />
							</IconButton>
						</div>: <div className={classes.displayFile} onClick={() => { handlePreview({ url: url, filType: fileType }); }}>
							{fileType === 'image'?<img className={classes.imgFile} src={url} alt='imgs' />:<video className={classes.videoFile}>
								<source src={url} type='video/mp4'/>
								Your browser does not support the video tag.
							</video>}
							{
								fileType === 'video' &&
								<div className='flexCol aCntr jCntr videoPlay pointer'>
									<div className='flexAutoCol aCntr jCntr pRel'>
										<PlayArrowRoundedIcon style={{ color: 'black' }} fontSize='large' />
									</div>
								</div>
							}
						</div>)
						:<>
							<div
								className={classnames(classes.fileInfo)}
								onClick={() => { handlePreview({ url: url, filType: fileType }); }}
							>
								{
								// fileType === 'pdf' ? <img alt='' src='/icons/pdf.svg' /> :
								// 	fileType === 'xlsx' ? <img alt='' src='/icons/excel.svg' /> :
								// 		fileType === 'ppt' ? <img alt='' src='/icons/ppt.svg' /> :
								// 			fileType === 'pptx' ? <img alt='' src='/icons/pptx.svg' />

									(fileType === 'pdf' || fileType === 'xlsx' || fileType === 'ppt' || fileType === 'pptx' || fileType === 'xls') ? <img className='customFileDisplay' alt='' src={`/documents/${fileType}.png`} />
										:<DescriptionIcon /> }
								<div className={classes.text}>
									<span className='ellipse'>{fileName}</span>
									{/* <small>{(size / (1024 * 1024)).toFixed(2)}MB</small> */}
								</div>
								{peerId !== window.btoa(me.email) &&
								<Tooltip
									title={intl.formatMessage({
										id             : 'filesharing.download',
										defaultMessage : 'Download'
									})}
									placement='top'
									enterDelay='700'
									enterNextDelay='700'
								>
									<IconButton
										size='small'
										variant='contained'
										component='span'
										className={classes.button}
										onClick={
											(e) =>
											{
												e.stopPropagation();
												handleDownload();
											}
										}
										aria-label={intl.formatMessage({
											id             : 'filesharing.download',
											defaultMessage : 'Download'
										})}
									>
										<GetAppIcon />
									</IconButton>
								</Tooltip>}
							</div>
							{/* <div>

							{file.active &&
								<progress value={file.progress} />
							}
						</div> */}
							{/* {!canShareFiles &&
							<div>
								<Alert severity='error'>
									<FormattedMessage
										id='label.fileSharingUnsupported'
										defaultMessage='File sharing not supported'
									/>
								</Alert>
							</div>
						} */}
						</>
					}
					{
						(fileType === 'image' || fileType === 'video') &&

						<div className={`flexInline aCntr jCntr  pointer ${window.btoa(me.email) === peerId ? 'downloadIconwidthClientSide' : 'downloadIconwidth'}`}
							onClick={
								() => roomClient.handleDownload(url, fileName)
							}
						>
							<Tooltip
								title={intl.formatMessage({
									id             : 'filesharing.download',
									defaultMessage : 'Download'
								})}
								placement='top'
							>
								<div className='flexRow aCntr jCntr pRel pdngHSM'>
									{peerId !== window.btoa(me.email) && <div className='downLoadWhiteIcon'>
										<img src='/icons/imageDownload.svg' alt='download' />
									</div>}
									<small className='wTxt pdngLSM'>{(size / (1024 * 1024)).toFixed(2) > 1 ? `${(size / (1024 * 1024)).toFixed(2)} MB` : `${(size / 1024).toFixed(2)} KB`}</small>
									{/* <small className='wTxt pdngLSM'>{(size / (1024 * 1024)).toFixed(2) > 1 ? `${
										(size / (1024 * 1024)).toFixed(2)} MB` : `${(size / 1024).toFixed(2)} KB`}</small> */ }
								</div>
							</Tooltip>
						</div>
					}
				</div>
				<div className='flexAutoRow gap8' >
					{isModerator && item?.replyTo && <small style={{ color: '#d19065', fontFamily: 'roboto' }}>Replied to {item?.replyData?.userName} </small>}
					<small style={{ fontFamily: 'roboto', textAlign: (peerId === window.btoa(me.email)) ? 'right' : 'left' }}>
						<FormattedTime value={new Date(time)} />
					</small>
				</div>
				{isModerator && window.btoa(me.email) !== peerId && <div className='reply1 pdn' onClick={() => setReplyData(item)}>
					<img className='pdngXXS' src='/icons/reply1.svg' alt='reply' />
				</div>}
			</div>

			{preview && preview.open && preview.data && <Preview handleClosePreview={() => { setPreview(!preview); setFileUrl({}); }} classes={classes} fname={fileUrl?.fileName} ftype={fileUrl?.fileType} furl={fileUrl?.fileURL} />}

			{/* { preview && preview.open && preview.data &&
			<div className={classes.previewWindow}>
				<div className='flexCol pdngSM fullH aEnd'><img className={classes.cImg} src='/icons/x.svg' alt='close' onClick={() => { setPreview(!preview); setFileUrl({}); }}/>
					<div className={classes.previewElememt}>
						<div className={classes.previewSub}>
							{preview.data.filType==='image' ? <img className={classes.imgFile} src={fileUrl?.fileURL} alt='imgs' />
								:<video className={classes.videoFile} controls>
									<source src={preview.data.url} type='video/mp4'/>
									Your browser does not support the video tag.
								</video>}
						</div>
					</div>
				</div>
			</div>
			} */}
		</div>
	);
};

File.propTypes = {
	roomClient          : PropTypes.object.isRequired,
	url                 : PropTypes.string.isRequired,
	time                : PropTypes.string.isRequired,
	name                : PropTypes.string.isRequired,
	picture             : PropTypes.string,
	canShareFiles       : PropTypes.bool.isRequired,
	file                : PropTypes.object.isRequired,
	classes             : PropTypes.object.isRequired,
	isseen              : PropTypes.bool,
	sender              : PropTypes.string.isRequired,
	refMessage          : PropTypes.object,
	width               : PropTypes.number.isRequired,
	format              : PropTypes.string,
	avatar              : PropTypes.string,
	chatBackgroundColor : PropTypes.string,
	fileName            : PropTypes.string,
	fileType            : PropTypes.string,
	size               	: PropTypes.any,
	webinarUser         : PropTypes.any,
	me                  : PropTypes.any,
	item                : PropTypes.any,
	setReplyData        : PropTypes.any,
	isModerator         : PropTypes.any,
	peerId              : PropTypes.any,
	index               : PropTypes.any,
	isPlaying           : PropTypes.any,
	setIsPlaying        : PropTypes.any,
	prew                : PropTypes.any,
	setPrew             : PropTypes.any,
	fileUrl             : PropTypes.any,
	setFileUrl          : PropTypes.any
};

const mapStateToProps = (state, { time }) =>
{
	const hasPermission = makePermissionSelector(permissions.MODERATE_ROOM);

	return {
		file          : state.files.broadcastFiles.filter((item) => item.sendTime === time)[0],
		canShareFiles : state.me.canShareFiles,
		me            : state.me,
		isModerator   : hasPermission(state)

	};
};

export default withRoomContext(connect(
	mapStateToProps,
	null,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.files === next.files &&
				prev.me.canShareFiles === next.me.canShareFiles
			);
		}
	}
)(withStyles(styles)(File)));